<template>
  <div class="page">
    <div class="card shadow-lg rounded-4 py-4" style="border:none" v-if="currentUser">
      <div class="card-body ">
        <div class="d-flex justify-content-between align-items-center mb-2 ">
          <h1 class="card-title text-uppercase m-0" style="font-weight:800; color: #444444">
            <span style="color: #0092f7">Cash</span> Up
          </h1>
          <div class="badge bg-primary p-2">{{ new Date().toLocaleDateString() }}</div>
        </div>

        <form @submit.prevent="confirmationText">
          <!-- Cashier Selection Section -->
          <div class="mb-4">
            <div class="section-header mb-2">
              <i class="fas fa-user-circle"></i> Cashier Information
            </div>
            <div class="p-3 bg-light rounded-3">
              <div class="form-floating" v-if="currentUser.Type.toLowerCase() !== 'admin'">
                <input type="text" class="form-control form-control-lg" v-model="cashup_user" id="floatingTextInput1"
                  placeholder="Cashier" required readonly>
                <label for="floatingTextInput1">Cashier</label>
              </div>

              <div v-else class="form-floating">
                <select v-model="cashup_user" class="form-select form-select-lg" id="current_cashup_user">
                  <option v-for="(user, n) in users" :key="n + 1" :value="user.Username">
                    {{ user.Username }}
                  </option>
                </select>
                <label for="current_cashup_user">Cashier</label>
              </div>
            </div>
          </div>

          <!-- Cash Denominations Section -->
          <div class="mb-4">
            <div class="section-header mb-2">
              <i class="fas fa-money-bill-wave"></i> Cash Denominations
              <span class="float-end badge bg-success fs-6">
                Total: {{ $utils.formatMoney(totalCashVal) }}
              </span>
            </div>

            <!-- Higher Denominations -->
            <div class="p-3 bg-light rounded-3 ">
    
              <div class="row g-3">
                <div class="col-md-4">
                  <div class="denomination-card high">
                    <div class="d-flex justify-content-between align-items-center ">
                      <h5>K500 Notes</h5>
                      <span class="badge bg-primary">{{ $utils.formatMoney(five_hundredsVal) }}</span>
                    </div>
                    <input type="number" min="0" class="form-control form-control-lg" v-model="cash.five_hundreds"
                      id="five_hundreds" placeholder="0">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="denomination-card high">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5>K200 Notes</h5>
                      <span class="badge bg-primary">{{ $utils.formatMoney(two_hundredsVal) }}</span>
                    </div>
                    <input type="number" min="0" class="form-control form-control-lg" v-model="cash.two_hundreds"
                      id="two_hundreds" placeholder="0">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="denomination-card high">
                    <div class="d-flex justify-content-between align-items-center ">
                      <h5>K100 Notes</h5>
                      <span class="badge bg-primary">{{ $utils.formatMoney(hundredsVal) }}</span>
                    </div>
                    <input type="number" min="0" class="form-control form-control-lg" v-model="cash.hundreds"
                      id="hundreds" placeholder="0">
                  </div>
                </div>
              </div>
            </div>

            <!-- Medium Denominations -->
            <div class="p-3 bg-light rounded-3 ">
              <div class="row g-3">
                <div class="col-md-4">
                  <div class="denomination-card medium">
                    <div class="d-flex justify-content-between align-items-center ">
                      <h5>K50 Notes</h5>
                      <span class="badge bg-info">{{ $utils.formatMoney(fiftiesVal) }}</span>
                    </div>
                    <input type="number" min="0" class="form-control form-control-lg" v-model="cash.fifties"
                      id="fifties" placeholder="0">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="denomination-card medium">
                    <div class="d-flex justify-content-between align-items-center ">
                      <h5>K20 Notes</h5>
                      <span class="badge bg-info">{{ $utils.formatMoney(twentiesVal) }}</span>
                    </div>
                    <input type="number" min="0" class="form-control form-control-lg" v-model="cash.twenties"
                      id="twenties" placeholder="0">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="denomination-card medium">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5>K10 Notes</h5>
                      <span class="badge bg-info">{{ $utils.formatMoney(tensVal) }}</span>
                    </div>
                    <input type="number" min="0" class="form-control form-control-lg" v-model="cash.tens" id="tens"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

           
            <div class="p-3 bg-light rounded-3">
              <div class="row g-3">
                <div class="col-md-4">
                  <div class="denomination-card low">
                    <div class="d-flex justify-content-between align-items-center ">
                      <h5>K5 Coins</h5>
                      <span class="badge bg-secondary">{{ $utils.formatMoney(fivesVal) }}</span>
                    </div>
                    <input type="number" min="0" class="form-control form-control-lg" v-model="cash.fives" id="fives"
                      placeholder="0">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="denomination-card low">
                    <div class="d-flex justify-content-between align-items-center ">
                      <h5>K2 coins</h5>
                      <span class="badge bg-secondary">{{ $utils.formatMoney(twosVal) }}</span>
                    </div>
                    <input type="number" min="0" class="form-control form-control-lg" v-model="cash.twos" id="twos"
                      placeholder="0">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="denomination-card low">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5>K1 Coins</h5>
                      <span class="badge bg-secondary">{{ $utils.formatMoney(onesVal) }}</span>
                    </div>
                    <input type="number" min="0" class="form-control form-control-lg" v-model="cash.ones" id="ones"
                      placeholder="0">
                  </div>
                </div>
              </div>
            </div>

            <!-- Coins -->
            <div class="p-3 bg-light rounded-3 mt-3">
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="denomination-card coins">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h5>50 Ngwee Coins</h5>
                      <span class="badge bg-dark">{{ $utils.formatMoney(fifty_ngweesVal) }}</span>
                    </div>
                    <input type="number" min="0" class="form-control form-control-lg" v-model="cash.fifty_ngwees"
                      id="fifty_ngwees" placeholder="0">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="denomination-card coins">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h5>10 Ngwee Coins</h5>
                      <span class="badge bg-dark">{{ $utils.formatMoney(ten_ngweesVal) }}</span>
                    </div>
                    <input type="number" min="0" class="form-control form-control-lg" v-model="cash.ten_ngwees"
                      id="ten_ngwees" placeholder="0">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Section -->
          <div class="mb-3">
            <div class="section-header mb-2">
              <i class="fas fa-calculator"></i> Payment Totals
            </div>
            <div class="p-2 bg-light rounded-3">
              <!-- Cash Total -->
              <div class="summary-item mb-2">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="mb-0"><i class="fas fa-money-bill-alt text-success me-2"></i> Cash Total</h5>
                  <h5 class="text-success fw-bold mb-0">{{ $utils.formatMoney(totalCashVal) }}</h5>
                </div>
                <div class="progress mt-1" style="height: 3px;">
                  <div class="progress-bar bg-success" role="progressbar" style="width: 100%"></div>
                </div>
              </div>

              <!-- Payment Methods Grid -->
              <div class="row g-2">
                <!-- Card -->
                <div class="col-md-3">
                  <div class="summary-item p-2">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0"><i class="fas fa-credit-card text-primary me-2"></i> Card Total</h5>
                    </div>
                    <input type="number" min="0" step="0.01" class="form-control form-control-sm mt-1" v-model="card" id="card-total" placeholder="Card total">
                  </div>
                </div>

                <!-- Other Payment Methods -->
                <div v-for="method in otherMethods" :key="method.id" class="col-md-3">
                  <div class="summary-item p-2">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0"><i class="fas fa-wallet text-info me-2"></i> {{ method.name }} Total</h5>
                    </div>
                    <input type="number" min="0" step="0.01" class="form-control form-control-sm mt-1" v-model="method.amount" :id="method.id + `-total`" :placeholder="`${method.name} total`">
                  </div>
                </div>
              </div>

              <!-- Grand Total -->
              <!-- <div class="summary-item mt-2 p-2 bg-dark text-white rounded-3">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="mb-0"><i class="fas fa-coins me-2"></i> Grand Total</h5>
                  <h5 class="fw-bold mb-0">{{ $utils.formatMoney(grandTotal) }}</h5>
                </div>
              </div> -->
            </div>
          </div>

          <!-- Submit Button -->
          <div class="text-center">
            <button :disabled="loading" type="submit" class="btn-cashup btn-lg">
              <span v-if="loading" class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
              <i class="fas fa-check-circle me-2"></i> Submit Cash Up ({{ $utils.formatMoney(grandTotal) }})
            </button>
          </div>
        </form>
      </div>
    </div>
    <FinalizeCashupSheet :cashup="cashup" ref="detailsheet" />
  </div>
</template>

<script>
import FinalizeCashupSheet from "@/components/point-of-sale/cashup/FinalizeCashupSheet";
import { Storage } from "@/services/Storage";

export default {
  name: "BasicCashupForm",
  components: { FinalizeCashupSheet },
  async beforeMount() {
    let user = await Storage.getCurrentUser();
    this.currentUser = user;

    this.users = await Storage.getAllUsers();
    this.cashup_user = user.Username;


    const hasPermission = await this.$store.dispatch('validateSecurityPermissionNoPrompt', 'cashupWithOpenTables');
    

    if (!hasPermission) {
        const { hasOpenTables, count } = await this.$store.dispatch('checkForOpenTables')
            .catch(error => {
                console.error('Error checking open tables:', error);
                return { hasOpenTables: false, count: 0 };
            });

        if (hasOpenTables) {
            await Swal.fire({
                icon: 'warning',
                title: 'Cannot Cash Up',
                text: `You have ${count} open table(s). Please close all tables before cashing up.`
            });
            this.$router.push({ name: 'tables' });
        }
    }
  },
  computed: {
    set() {
      return this.$store.getters.getDeviceSettings
    },
    five_hundredsVal() {
      return Number(Number(this.cash.five_hundreds) * 500)
    },
    two_hundredsVal() {
      return Number(Number(this.cash.two_hundreds) * 200)
    },
    hundredsVal() {
      return Number(Number(this.cash.hundreds) * 100)
    },
    fiftiesVal() {
      return Number(Number(this.cash.fifties) * 50)
    },
    twentiesVal() {
      return Number(Number(this.cash.twenties) * 20)
    },
    tensVal() {
      return Number(Number(this.cash.tens) * 10)
    },
    fivesVal() {
      return Number(Number(this.cash.fives) * 5)
    },
    twosVal() {
      return Number(Number(this.cash.twos) * 2)
    },
    onesVal() {
      return Number(this.cash.ones)
    },
    fifty_ngweesVal() {
      return Number(Number(this.cash.fifty_ngwees) * 0.5)
    },
    ten_ngweesVal() {
      return Number(Number(this.cash.ten_ngwees) * 0.1)
    },
    otherMethods() {
      if (this.otherPayments.length === 0) {
        this.otherPayments = this.$store.getters.getPaymentMethods
          .filter(method => method.active)
          .map(method => ({
            ...method,
            amount: 0
          }));
      }
      return this.otherPayments;
    },
    totalCashVal() {
      return this.five_hundredsVal
        + this.two_hundredsVal
        + this.hundredsVal
        + this.fiftiesVal
        + this.twentiesVal
        + this.tensVal
        + this.fivesVal
        + this.twosVal
        + this.onesVal
        + this.fifty_ngweesVal
        + this.ten_ngweesVal
    },
    grandTotal() {
    
      
      let otherTotal = this.otherMethods.reduce((sum, method) => {
        let amount = Number(method.amount) || 0;
        return sum + amount;
      }, 0);
      
      return this.totalCashVal + Number(this.card) + otherTotal;
    },
    loading() {
      return this.$store.getters.getLoadingState;
    },
  },
  data() {
    return {
      cashup: {},
      pc_cashup: false,
      cashup_user: '',
      currentUser: null,
      users: [],
      cash: {
        five_hundreds: 0,
        two_hundreds: 0,
        hundreds: 0,
        fifties: 0,
        twenties: 0,
        tens: 0,
        fives: 0,
        twos: 0,
        ones: 0,
        fifty_ngwees: 0,
        ten_ngwees: 0,
      },
      card: 0,
      otherPayments: []
    }
  },

  methods: {
    async confirmationText() {
      try {

        const hasPermission = await this.$store.dispatch('validateSecurityPermissionNoPrompt', 'cashupWithOpenTables');
        
        
        if (!hasPermission) {
            const { hasOpenTables, count } = await this.$store.dispatch('checkForOpenTables');
            if (hasOpenTables) {
                return Swal.fire({
                    icon: 'warning',
                    title: 'Cannot Cash Up',
                    text: `You have ${count} open table(s). Please close all tables before cashing up.`
                });
            }
        }


        return Swal.fire({
          title: 'Are you sure?',
          text: "Please make sure your figures are correct!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, I am sure!'
        }).then((result) => {
          if (result.isConfirmed) {
            return this.submitCashUp();
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    },
    async submitCashUp() {
      let other = this.otherMethods.map(method => {
        return {
          id: method.id,
          amount: Number(method.amount)
        }
      });
      
      // Calculate total of other payments
      let otherTotal = other.reduce((sum, method) => sum + method.amount, 0);
      
      let settings = await Storage.getDeviceSettings();
      let data = {
        cash: parseFloat(this.totalCashVal),
        card: parseFloat(this.card),
        other: other,
        otherTotal: otherTotal,
        pc: settings.PC,
        user: this.cashup_user,
      }
      let isAllowed = await this.$store.dispatch(`validateSecurityPermissionNoPrompt`, `viewCashupDetails`);
      // if (!isAllowed) {
      //   return this.$store.dispatch('cashUpUser', data)
      //     .then(() => this.$router.push({ name: 'float' }))
      //     .finally(() => this.$utils.hideLoading())
      // }
      this.$utils.showLoading()
      return this.$store.dispatch('getcashUpDiff', data)
        .then((res) => {
          this.cashup = res.response;
          this.openSheet();
        }).finally(() => this.$utils.hideLoading());
    },
    openSheet() {
      this.$refs.detailsheet.open();
    },
  }

}
</script>

<style lang="scss" scoped>
.page {
  overflow-y: scroll;
  overflow-x: hidden;
  padding-bottom: 20px;
}

.section-header {
  font-weight: 600;
  font-size: 1rem;
  color: #444;
  padding-bottom: 3px;
  border-bottom: 1px solid #e0e0e0;
}

.denomination-card {
  background-color: white;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  &.high {
    border-left: 4px solid #0d6efd;
  }

  &.medium {
    border-left: 4px solid #0dcaf0;
  }

  &.low {
    border-left: 4px solid #6c757d;
  }

  &.coins {
    border-left: 4px solid #212529;
  }

  h5 {
    font-size: 0.9rem;
  }

  input {
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
  }
}

.summary-item {
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f8f9fa;
  }

  h5 {
    font-size: 0.9rem;
  }
}

.btn-cashup {
  background: linear-gradient(135deg, #1e88e5, #0062cc);
  color: white;
  font-weight: 600;
  display: block;
  width: 100%;
  height: 45px;
  margin-bottom: 10px;
  border-radius: 8px;
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #0062cc, #004a9f);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
</style>